import {Pipe, PipeTransform} from '@angular/core';
import {OperationDto} from '../../../Models/Warehouse/Operations/operation.interface';
import {InventoryDto} from '../../../Models/Warehouse/Inventories/inventory.interface';
import {RevisionDto} from '../../../Models/Warehouse/Revisions/revision.interface';
import {ReloadDto} from '../../../Models/Warehouse/Reloads/reload.interface';

@Pipe({
  name: 'operations',
  standalone: false
})
export class OperationsPipe implements PipeTransform {

  transform(items: OperationDto, menuSegment: string, filters: {
    local?: number,
    location?: number
  }) {

    if (!items) {
      return [];
    }

    let list: (InventoryDto | RevisionDto | ReloadDto)[] = [];

    switch (menuSegment) {
      case 'inventories':
        list = items.inventarios;
        break;

      case 'revisions':
        list = items.revisiones;
        break;

      case 'reloads':
        list = items.recargas;
        break;
    }

    if (filters.local) {
      list = list.filter((item) => item.id_local === filters.local);
    }

    if (filters.location) {
      list = list.filter((item) => item.id_ubicacion === filters.location);
    }

    return list;

  }

}
